module.exports = __webpack_public_path__ + "img/p8.a796791a.png";